var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecklist = function SvgChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2417_7635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 7.50005H13V9.50005H22V7.50005ZM22 15.5001H13V17.5001H22V15.5001ZM5.54 11.5001L2 7.96005L3.41 6.55005L5.53 8.67005L9.77 4.43005L11.18 5.84005L5.54 11.5001ZM5.54 19.5001L2 15.9601L3.41 14.5501L5.53 16.6701L9.77 12.4301L11.18 13.8401L5.54 19.5001Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2417_7635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
export default SvgChecklist;